import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Import all components
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import FeaturesSection from './components/FeaturesSection';
import ROICalculator from './components/ROICalculator';
import PricingSection from './components/PricingSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import DemoSection from './components/DemoSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

// Register GSAP plugins
gsap?.registerPlugin(ScrollTrigger);

const LandingPage = () => {
  useEffect(() => {
    // Smooth scrolling for anchor links
    const handleSmoothScroll = (e) => {
      const target = e?.target?.getAttribute('href');
      if (target && target?.startsWith('#')) {
        e?.preventDefault();
        const element = document.querySelector(target);
        if (element) {
          gsap?.to(window, {
            duration: 1,
            scrollTo: { y: element, offsetY: 80 },
            ease: 'power2.inOut',
          });
        }
      }
    };

    // Add event listeners to all anchor links
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks?.forEach((link) => {
      link?.addEventListener('click', handleSmoothScroll);
    });

    // Cleanup
    return () => {
      anchorLinks?.forEach((link) => {
        link?.removeEventListener('click', handleSmoothScroll);
      });
    };
  }, []);

  useEffect(() => {
    // Global scroll animations
    const ctx = gsap?.context(() => {
      // Parallax effect for background elements
      gsap?.utils?.toArray('.parallax-bg')?.forEach((bg) => {
        gsap?.to(bg, {
          yPercent: -50,
          ease: 'none',
          scrollTrigger: {
            trigger: bg,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        });
      });

      // Fade in animations for sections
      gsap?.utils?.toArray('section')?.forEach((section) => {
        gsap?.fromTo(
          section,
          { opacity: 0.8 },
          {
            opacity: 1,
            duration: 0.5,
            scrollTrigger: {
              trigger: section,
              start: 'top 90%',
              end: 'top 70%',
              scrub: true,
            },
          }
        );
      });
    });

    return () => ctx?.revert();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation would go here in a real app */}

      {/* Hero Section */}
      <HeroSection />

      {/* Problem Agitation Section */}
      <ProblemSection />

      {/* Solution Overview Section */}
      <SolutionSection />

      {/* Interactive Features Section */}
      <FeaturesSection />

      {/* ROI Calculator Section */}
      <ROICalculator />

      {/* Pricing Section */}
      <PricingSection />

      {/* Customer Testimonials Section */}
      <TestimonialsSection />

      {/* FAQ Section */}
      {/* <FAQSection /> */}

      {/* Demo Request Section */}
      <DemoSection />

      {/* Contact Sales Section */}
      <ContactSection />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;
